import React, { useLayoutEffect, useRef, useState } from 'react';

export const HOST_LAYOUT_WIDTH = 1700
// 24px padding + 958px board/slide + 320px podiums/wagers.
// Round controls now share the GameInfo space below the board.
export const HOST_LAYOUT_HEIGHT = 1302

// Only the viewport determines the scale. Reserve the full game layout even
// when podiums or wager inputs are not currently visible.
function HostViewport({ children }) {
  const viewportRef = useRef(null)
  const [scale, setScale] = useState(1)

  useLayoutEffect(() => {
    const viewport = viewportRef.current
    const fit = () => {
      setScale(Math.min(viewport.clientWidth / HOST_LAYOUT_WIDTH, viewport.clientHeight / HOST_LAYOUT_HEIGHT))
    }

    const observer = new ResizeObserver(fit)
    observer.observe(viewport)
    fit()
    return () => observer.disconnect()
  }, [])

  return (
    <div className="host-client" ref={viewportRef}>
      <div className="host-frame" style={{ width: HOST_LAYOUT_WIDTH * scale, height: HOST_LAYOUT_HEIGHT * scale }}>
        <div className="host-content" style={{ width: HOST_LAYOUT_WIDTH, height: HOST_LAYOUT_HEIGHT, transform: `scale(${scale})` }}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default HostViewport;
